import produce from 'immer';

import { createAction } from '../context-utils';

export const cacheSetAction = createAction<CacheType>((state: CacheType, payload: { [key: string]: any }) => {
  return produce(state, (draft) => {
    draft.store = { ...draft.store, ...payload };
  });
});
